import type { ReportTemplate } from '../../schemas';

export const CHIUSURA_SECTIONS: ReportTemplate['sections'] = [
  {
    id: 'sec_esiti-non-conformita-rilievi',
    name: 'Esiti (non conformità / rilievi)',
    type: 'repeating',
    repeat: {
      forEach: 'visit.findings',
      as: 'f',
    },
    fields: [
      {
        id: 'fld_codice',
        label: 'Codice',
        type: 'text',
        source: '{{f.code}}',
        placeholder: 'Es. F-001',
        _idHistory: {
          derivedFrom: 'Codice',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_gravita',
        label: 'Gravità',
        type: 'choice',
        source: '{{f.severity}}',
        options: [
          {
            value: 'low',
            label: 'Bassa',
          },
          {
            value: 'medium',
            label: 'Media',
          },
          {
            value: 'high',
            label: 'Alta',
          },
          {
            value: 'critical',
            label: 'Critica',
          },
        ],
        _idHistory: {
          derivedFrom: 'Gravità',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_unita',
        label: 'Impianto',
        type: 'text',
        source: '{{f.unitName}}',
        _idHistory: {
          derivedFrom: 'Impianto',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_descrizione',
        label: 'Descrizione',
        type: 'text',
        format: 'multiline',
        source: '{{f.text}}',
        _idHistory: {
          derivedFrom: 'Descrizione',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_riferimenti-normativi',
        label: 'Riferimenti normativi',
        type: 'text',
        format: 'multiline',
        source: '{{f.regulationRefs}}',
        _idHistory: {
          derivedFrom: 'Riferimenti normativi',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [
      {
        type: 'table',
        id: 'tbl_grafici-valutazione',
        columns: [
          {
            id: 'date',
            label: 'Data',
            fieldPath: "date | date('MM/YYYY','it-IT')",
            width: '12%',
          },
          {
            id: 'disponibilita',
            label: 'Disponibilità',
            fieldPath: "disponibilita + ' ' + disponibilita | bar(10)",
            width: '17%',
          },
          {
            id: 'interesse',
            label: 'Interesse',
            fieldPath: "interesse + ' ' + interesse | bar(10)",
            width: '17%',
          },
          {
            id: 'efficienza',
            label: 'Efficienza',
            fieldPath: "efficienza + ' ' + efficienza | bar(10)",
            width: '17%',
          },
          {
            id: 'documentale',
            label: 'Documentale',
            fieldPath: "documentale + ' ' + documentale | bar(10)",
            width: '17%',
          },
          {
            id: 'sicurezza',
            label: 'Sicurezza',
            fieldPath: "sicurezza + ' ' + sicurezza | bar(10)",
            width: '20%',
          },
        ],
        rowSource: '{{ visit.scorecard.byDate }}',
        emptyMessage: 'Nessun dato disponibile per i grafici',
        headerStyle: 'bold',
      },
    ],
    navigationGroup: {
      id: 'chiusura-azioni',
      label: 'Chiusura',
      order: 4,
      icon: 'assignment_turned_in',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_azioni-correttive',
    name: 'Azioni correttive',
    type: 'repeating',
    repeat: {
      forEach: 'visit.actions',
      as: 'a',
    },
    fields: [
      {
        id: 'fld_titolo',
        label: 'Titolo',
        type: 'text',
        source: '{{a.title}}',
        _idHistory: {
          derivedFrom: 'Titolo',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_responsabile',
        label: 'Responsabile',
        type: 'text',
        source: '{{a.ownerName}}',
        _idHistory: {
          derivedFrom: 'Responsabile',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_scadenza',
        label: 'Scadenza',
        type: 'date',
        source: '{{a.due}}',
        _idHistory: {
          derivedFrom: 'Scadenza',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_stato',
        label: 'Stato',
        type: 'choice',
        source: '{{a.status}}',
        options: [
          {
            value: 'open',
            label: 'Aperta',
          },
          {
            value: 'in_progress',
            label: 'In corso',
          },
          {
            value: 'done',
            label: 'Chiusa',
          },
          {
            value: 'waived',
            label: 'Esclusa',
          },
        ],
        _idHistory: {
          derivedFrom: 'Stato',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
      {
        id: 'fld_collegata-a-esito',
        label: 'Collegata a esito',
        type: 'text',
        source: '{{a.findingCode}}',
        _idHistory: {
          derivedFrom: 'Collegata a esito',
          generatedAt: '2025-12-29T23:08:52.381Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'chiusura-azioni',
      label: 'Chiusura',
      order: 4,
      icon: 'assignment_turned_in',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_scheda-di-valutazione',
    name: 'Scheda di valutazione',
    type: 'static',
    fields: [
      {
        id: 'fld_data-valutazione',
        label: 'Data valutazione',
        type: 'date',
        editing: {
          state: 'computed',
          reason: 'Gestita dalla cronologia del report',
        },
        _idHistory: {
          derivedFrom: 'Data valutazione',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_disp-pianificazione',
        label: 'Pianificazione',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Pianificazione',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_disp-presenza-personale-patentato',
        label: 'Presenza personale patentato',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Presenza personale patentato',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_disp-partecipazione-formazione',
        label: 'Partecipazione alla formazione',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Partecipazione alla formazione',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_disp-esecuzione-prove',
        label: 'Esecuzione delle prove',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Esecuzione delle prove',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_int-durante-sopralluogo',
        label: 'Durante il sopralluogo',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Durante il sopralluogo',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_int-durante-formazione',
        label: 'Durante la formazione',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Durante la formazione',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_int-approfondimento-conoscenze',
        label: 'Approfondimento conoscenze',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Approfondimento conoscenze',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_int-sensibilita-sicurezza',
        label: 'Sensibilità alla sicurezza',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Sensibilità alla sicurezza',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_eff-ordine-locali',
        label: 'Ordine dei locali',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Ordine dei locali',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_eff-pulizia-locali',
        label: 'Pulizia dei locali',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Pulizia dei locali',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_eff-tempi-risposta',
        label: 'Tempi di risposta a richieste',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tempi di risposta a richieste',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_eff-tempi-esecuzione',
        label: 'Tempi di esecuzione interventi',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Tempi di esecuzione interventi',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_eff-puntualita-interventi',
        label: 'Puntualità interventi periodici',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Puntualità interventi periodici',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_doc-facilita-accesso',
        label: 'Facilità accesso ai documenti',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Facilità accesso ai documenti',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_doc-completezza',
        label: 'Completezza informazioni',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Completezza informazioni',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_sicurezza-complessiva',
        label: 'Sicurezza complessiva',
        type: 'number',
        validation: {
          min: 0,
          max: 10,
        },
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Sicurezza complessiva',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_note-disponibilita',
        label: 'Note disponibilità',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note disponibilità',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_note-interesse',
        label: 'Note interesse',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note interesse',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_note-efficienza',
        label: 'Note efficienza',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note efficienza',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_note-documentale',
        label: 'Note stato documentale',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note stato documentale',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
      {
        id: 'fld_note-sicurezza',
        label: 'Note sicurezza complessiva',
        type: 'text',
        format: 'multiline',
        editing: {
          state: 'editable',
        },
        _idHistory: {
          derivedFrom: 'Note sicurezza complessiva',
          generatedAt: '2026-01-06T12:00:00.000Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [
      {
        type: 'scorecard-chart',
        title: 'Disponibilità al sopralluogo',
        noteFieldId: 'fld_note-disponibilita',
        dateFieldId: 'fld_data-valutazione',
        maxPoints: 4,
        series: [
          {
            id: 'pianificazione',
            label: 'Pianificazione',
            fieldId: 'fld_disp-pianificazione',
            color: '#052664',
          },
          {
            id: 'personale-patentato',
            label: 'Presenza personale patentato',
            fieldId: 'fld_disp-presenza-personale-patentato',
            color: '#EF4444',
          },
          {
            id: 'formazione',
            label: 'Partecipazione alla formazione',
            fieldId: 'fld_disp-partecipazione-formazione',
            color: '#16A34A',
          },
          {
            id: 'prove',
            label: 'Esecuzione delle prove',
            fieldId: 'fld_disp-esecuzione-prove',
            color: '#7C3AED',
          },
        ],
      },
      {
        type: 'scorecard-chart',
        title: 'Livello di interesse e attenzione',
        noteFieldId: 'fld_note-interesse',
        dateFieldId: 'fld_data-valutazione',
        maxPoints: 4,
        series: [
          {
            id: 'sopralluogo',
            label: 'Durante il sopralluogo',
            fieldId: 'fld_int-durante-sopralluogo',
            color: '#052664',
          },
          {
            id: 'formazione',
            label: 'Durante la formazione',
            fieldId: 'fld_int-durante-formazione',
            color: '#EF4444',
          },
          {
            id: 'conoscenze',
            label: 'Approfondimento conoscenze',
            fieldId: 'fld_int-approfondimento-conoscenze',
            color: '#16A34A',
          },
          {
            id: 'sensibilita',
            label: 'Sensibilità alla sicurezza',
            fieldId: 'fld_int-sensibilita-sicurezza',
            color: '#7C3AED',
          },
        ],
      },
      {
        type: 'scorecard-chart',
        title: 'Stato di efficienza',
        noteFieldId: 'fld_note-efficienza',
        dateFieldId: 'fld_data-valutazione',
        maxPoints: 4,
        series: [
          {
            id: 'ordine',
            label: 'Ordine dei locali',
            fieldId: 'fld_eff-ordine-locali',
            color: '#052664',
          },
          {
            id: 'pulizia',
            label: 'Pulizia dei locali',
            fieldId: 'fld_eff-pulizia-locali',
            color: '#EF4444',
          },
          {
            id: 'risposta',
            label: 'Tempi di risposta a richieste',
            fieldId: 'fld_eff-tempi-risposta',
            color: '#16A34A',
          },
          {
            id: 'esecuzione',
            label: 'Tempi di esecuzione interventi',
            fieldId: 'fld_eff-tempi-esecuzione',
            color: '#7C3AED',
          },
          {
            id: 'puntualita',
            label: 'Puntualità interventi periodici',
            fieldId: 'fld_eff-puntualita-interventi',
            color: '#0EA5E9',
          },
        ],
      },
      {
        type: 'scorecard-chart',
        title: 'Stato documentale',
        noteFieldId: 'fld_note-documentale',
        dateFieldId: 'fld_data-valutazione',
        maxPoints: 4,
        series: [
          {
            id: 'accesso',
            label: 'Facilità accesso ai documenti',
            fieldId: 'fld_doc-facilita-accesso',
            color: '#052664',
          },
          {
            id: 'completezza',
            label: 'Completezza informazioni',
            fieldId: 'fld_doc-completezza',
            color: '#EF4444',
          },
        ],
      },
      {
        type: 'scorecard-chart',
        title: 'Livello di sicurezza complessivo',
        noteFieldId: 'fld_note-sicurezza',
        dateFieldId: 'fld_data-valutazione',
        maxPoints: 4,
        series: [
          {
            id: 'complessivo',
            label: 'Sicurezza complessiva',
            fieldId: 'fld_sicurezza-complessiva',
            color: '#052664',
          },
        ],
      },
    ],
    viewBlocksMode: 'replace',
    navigationGroup: {
      id: 'chiusura-azioni',
      label: 'Chiusura',
      order: 4,
      icon: 'assignment_turned_in',
    },
    layout: {
      columns: 2,
    },
  },
];
